import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { AppointmentDialogComponent } from '../dialog/appointment-dialog/appointment-dialog.component';
import { UserService } from '../core/services/v2/user.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isLoggedIn: boolean = false;
  isExpanded = false;

  constructor(private userService: UserService, public dialog: MatDialog) {

    this.userService.getUserDetails().subscribe(
      () => { this.isLoggedIn = true; },
      (error) => {
        console.error(error);
        this.isLoggedIn = false;
      }
    );
  }


  ngOnInit() {
    // this.userService.getUserDetails().subscribe(result => {})
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }


  openAppointmentDialog() {
    this.dialog.open(AppointmentDialogComponent, {
      width: '700px',
      minHeight: '400px'
    });
  }
}
;
